// extracted by mini-css-extract-plugin
module.exports = {"trustedShopContainer":"trusted-shops-badge_trustedShopContainer__okuCd","trustedShopText":"trusted-shops-badge_trustedShopText__E2gDH"};